export const NewSupplier = {
  labelName: 'Nome',
  labelSurname: 'Apelido',
  labelPerfil: 'Perfil',
  labelPartner: 'Parceiro',
  labelEmail: 'Email',
  labelSuppier: 'Fornecedor',
  profilePlaceholder: 'Escolha o Perfil',
  supplierPlaceholder: 'Escolha o Fornecedor',
  ROLE_SUPPLIER: 'Fornecedor',
  ROLE_SUPPLIER_ADMIN: 'Administrador - Fornecedor'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/NewSupplier.js